import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b969b80a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "product-actions align-items-lg-start flex-lg-row ml-lg-0" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-spin pi-spinner" }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_ColumnProductName = _resolveComponent("ColumnProductName")!
  const _component_Column = _resolveComponent("Column")!
  const _component_ColumnExpertInfo = _resolveComponent("ColumnExpertInfo")!
  const _component_PriceSummary = _resolveComponent("PriceSummary")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createBlock(_component_DataTable, {
    breakpoint: "1150px",
    "data-key": "id",
    "responsive-layout": "stack",
    value: _ctx.cartLineClients
  }, {
    default: _withCtx(() => [
      _createVNode(_component_Column, {
        field: "productName",
        header: _ctx.$t('cart.table.colName'),
        style: { width: '25%' }
      }, {
        body: _withCtx((item) => [
          _createVNode(_component_ColumnProductName, {
            item: _ctx.productNameColumnModel(item.data)
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                (_ctx.canChangeConfiguration(item.data))
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      class: "p-button-secondary p-button-text flex-shrink-0 hidden-print",
                      icon: "pi pi-cog",
                      label: _ctx.$t('cart.button.editConfiguration'),
                      title: _ctx.$t('cart.button.editConfiguration'),
                      onClick: ($event: any) => (_ctx.changeConfiguration(item.data))
                    }, null, 8, ["label", "title", "onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.canRemoveItem(item.data))
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      class: "p-button-secondary p-button-text flex-shrink-0 hidden-print",
                      icon: "pi pi-times",
                      label: _ctx.$t('cart.button.removeItem'),
                      title: _ctx.$t('cart.button.removeItem'),
                      onClick: ($event: any) => (_ctx.confirmRemoveItem(item.data))
                    }, null, 8, ["label", "title", "onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 2
          }, 1032, ["item"])
        ]),
        _: 1
      }, 8, ["header"]),
      _createVNode(_component_Column, null, {
        body: _withCtx((item) => [
          _createVNode(_component_ColumnExpertInfo, {
            item: item.data
          }, null, 8, ["item"])
        ]),
        _: 1
      }),
      _createVNode(_component_Column, {
        header: _ctx.$t('cart.table.colPrice'),
        style: {"width":"35%"}
      }, {
        body: _withCtx((item) => [
          (!_ctx.isSpinnerVisible(item.data.name))
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_PriceSummary, {
                  vm: _ctx.priceSummary(item.data)
                }, null, 8, ["vm"])
              ]))
            : (_ctx.isSpinnerVisible(item.data.name))
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
              : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["header"])
    ]),
    _: 1
  }, 8, ["value"]))
}